import yup from 'core/utils/validators';
import {
  FIELD_REQUIRED,
  INVALID_EMAIL,
  EMAIL_IS_REQUIRED,
  INVALID_BIRTHDAY,
  FIELD_BAD_LENGTH,
  FIELD_MIN_TWO_LENGTH,
} from 'const';

const { object, string, date } = yup;

export const personalDataFormSchema = (oldCustomerBirthDate: Date) =>
  object().shape({
    first_name: string()
      .min(2, FIELD_MIN_TWO_LENGTH)
      .max(50, FIELD_BAD_LENGTH)
      .required(FIELD_REQUIRED),
    last_name: string()
      .min(2, FIELD_MIN_TWO_LENGTH)
      .max(50, FIELD_BAD_LENGTH)
      .required(FIELD_REQUIRED),
    gender: string().required(FIELD_REQUIRED),
    birthday: date()
      .typeError(INVALID_BIRTHDAY)
      .required(FIELD_REQUIRED)
      .min(oldCustomerBirthDate, INVALID_BIRTHDAY)
      .max(new Date(), INVALID_BIRTHDAY),
    pan_card_number: string().min(12, 'Incorrect code').required(FIELD_REQUIRED),
    email: string().required(EMAIL_IS_REQUIRED).email(INVALID_EMAIL),
    preferable_language_id: string().nullable().required(FIELD_REQUIRED),
  });
